import { useEffect } from "react";
import { storeIdentifiers, getAdsProporties } from "@/lib/identifiers";
import { getSalesPersonData } from "@/lib/get-sales-person-data";
import { getTrackingKey } from "@/lib/monitoring/oci";
import { useLocation } from "react-router-dom";
import { rudderanalytics } from "@/lib/rudderstack";

export const EventTracking = () => {
  const location = useLocation();

  const storeIdentifiersAndTrackEvent = async () => {
    await storeIdentifiers();
  };

  useEffect(() => {
    getSalesPersonData();
    storeIdentifiersAndTrackEvent();
    getTrackingKey();
  }, []);

  const sendPageEvent = async () => {
    const { pathname, search } = location;
    const fullUrl = window.location.origin + pathname + search;
    const properties = await getAdsProporties();

    rudderanalytics.page(pathname, {
      path: pathname,
      url: fullUrl,
      title: document.title,
      referrer: document.referrer,
      ...properties,
    });
  };

  useEffect(() => {
    sendPageEvent();
  }, [location]);

  return null;
};
